// extracted by mini-css-extract-plugin
export var border = "_18-8";
export var brand = "_18-t";
export var button = "_18-l";
export var center = "_18-a";
export var centered = "_18-6";
export var closeButton = "_18-c";
export var disabledWrapper = "_18-m";
export var error = "_18-p";
export var extraLarge = "_18-4";
export var extraSmall = "_18-1";
export var fill = "_18-i";
export var footer = "_18-h";
export var footerAction = "_18-j";
export var footerButtons = "_18-k";
export var header = "_18-7";
export var headerWithClose = "_18-d";
export var icon = "_18-o";
export var info = "_18-s";
export var inline = "_18-9";
export var large = "_18-3";
export var main = "_18-e";
export var modal = "_18-0";
export var nearFull = "_18-5";
export var neutral = "_18-u";
export var noPadding = "_18-g";
export var none = "_18-v";
export var scrollable = "_18-f";
export var small = "_18-2";
export var success = "_18-r";
export var tight = "_18-n";
export var titleIcon = "_18-b";
export var warn = "_18-q";